import React, { createContext, useState, useEffect } from "react";
import useLocalStorage from "hooks/useLocalStorage";

import axios from "axios";
import numberify from "utils/shared/numberify";
import useSWR from "swr";
import { useCollection } from "@nandorojo/swr-firestore";
import { useToast } from "@chakra-ui/core";

// Create context
export const ContextStore = createContext({});

const fetcher = (url) => axios.get(url).then((res) => res.data);

// Provider with data inside
export const StoreProvider = ({ children }) => {
  const [openFood, setOpenFood] = useState();
  const [isBasketOpen, setBasketOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [basketOrders, setBasketOrders] = useLocalStorage("basketOrders", []);
  const [eatingPlace, setEatingPlace] = useLocalStorage("eatingPlace", {
    value: "aEmporter",
    changedAt: new Date("2020-01-01"),
  });
  const [currentOrder, setCurrentOrder] = useState();
  const [today, setToday] = useState();
  const [timeNow, setTimeNow] = useState();
  const [ouvert, setOuvert] = useState();
  const [isStoreManuallyClosed, setIsStoreManuallyClosed] = useState(false);
  const [isDashboardOnline, setIsDashboardOnline] = useState(false);
  const [adminFood, setAdminFood] = useState();
  const [waitingTime, setWaitingTime] = useState();

  const { data, error, isValidating } = useSWR("/api/time", fetcher, {
    refreshInterval: 60000,
    revalidateOnFocus: false,
  });

  const { data: openingHoursData } = useCollection(
    "hours",
    { listen: true },
    {
      revalidateOnFocus: false,
    }
  );

  const [settings, setSettings] = useState();
  const [openingHours, setOpeningHours] = useState();

  const [isOpeningTime, setIsOpeningTime] = useState(false);

  useEffect(() => {
    if (openingHoursData) {
      const settingsData = openingHoursData.filter((h) => h.id === "--settings--");

      const filteredOpeningHours = openingHoursData.filter((h) => h.id !== "--settings--");

      filteredOpeningHours.sort(function (a, b) {
        return a.number - b.number;
      });

      setOpeningHours(filteredOpeningHours);
      setSettings(settingsData[0]);
    }
  }, [openingHoursData]);

  useEffect(() => {
    if (data && !isValidating && openingHours && settings) {
      const serverToday = openingHours[data.dayOfWeek - 1];
      setToday(serverToday);
      setTimeNow(data.serverTimeNow);
      setWaitingTime(settings.timeSlots);
      setIsStoreManuallyClosed(settings.storeClosed);
      // TODO: Reactivate when found a working solution...
      // setIsDashboardOnline(settings.isDashboardOnline?.state && settings.isDashboardUpdated); // Dashboard Online and App is Updated
      setIsDashboardOnline(settings.isDashboardUpdated); // Dashboard Online NOPE and App is Updated YUP
      if (
        (numberify(data.serverTimeNow) > numberify(serverToday.openAM) &&
          numberify(data.serverTimeNow) < numberify(serverToday.closeAM)) ||
        (numberify(data.serverTimeNow) > numberify(serverToday.openPM) &&
          numberify(data.serverTimeNow) < numberify(serverToday.closePM === "00:00" ? "24:00" : serverToday.closePM))
      ) {
        setIsOpeningTime(true);
        if (settings.storeClosed === false) {
          setOuvert(true);
        } else {
          setOuvert(false);
        }
      } else {
        setOuvert(false);
        setIsOpeningTime(false);
      }
    }
  }, [isValidating, data, openingHours]);

  const [toastMessage, showToast] = useState(undefined);
  const toast = useToast();

  useEffect(() => {
    if (toastMessage) {
      const { title, body, type } = toastMessage;

      toast({
        title,
        description: body,
        status: type || "success",
        duration: 9000,
        isClosable: true,
        position: "top",
      });
    }
  }, [toastMessage, toast]);

  // TODO: Agrandir la liste de messages d'erreurs plus tard
  const errorMessagesList = {
    "auth/invalid-verification-code": "Code de vérification invalide, veuillez réessayer.",
    "auth/credential-already-in-use": "Cet identifiant est déjà utilisé par un autre utilisateur.",
  };

  const handleError = (errorData) => {
    const { title, error } = errorData;
    const toastBody = errorMessagesList[error.code] || error.message || "Une erreur est survenue.";

    showToast({ title: title || "Erreur", body: toastBody, type: "error" });
  };

  return (
    <ContextStore.Provider
      value={{
        openFood,
        setOpenFood,
        currentOrder,
        setCurrentOrder,
        adminFood,
        setAdminFood,
        basketOrders,
        setBasketOrders,
        isBasketOpen,
        setBasketOpen,
        isModalOpen,
        setModalOpen,
        eatingPlace,
        setEatingPlace,
        today,
        setToday,
        timeNow,
        setTimeNow,
        ouvert: process.env.NODE_ENV === "development" ? true : ouvert,
        setOuvert,
        isOpeningTime: process.env.NODE_ENV === "development" ? true : isOpeningTime,
        openingHours,
        waitingTime,
        settings,
        showToast,
        handleError,
        isStoreManuallyClosed: process.env.NODE_ENV === "development" ? false : isStoreManuallyClosed,
        isDashboardOnline: process.env.NODE_ENV === "development" ? true : isDashboardOnline,
      }}
    >
      {children}
    </ContextStore.Provider>
  );
};
